import React, { useEffect, useState } from "react";
import Constaint from "../../../layout/components/Constaint";
import StartMockBtn from "./StartMockBtn";

const FeaturedVideo = () => {
  const [dimensions, setDimensions] = useState({ width: 560, height: 315 });

  useEffect(() => {
    const updateDimensions = () => {
      const windowWidth = window.innerWidth;

      if (windowWidth >= 1024) {
        // Large screens (Desktop)
        setDimensions({ width: 800, height: 450 });
      } else if (windowWidth >= 768) {
        // Medium screens (Tablet)
        setDimensions({ width: 640, height: 360 });
      } else {
        // Small screens (Mobile)
        setDimensions({ width: 360, height: 202 });
      }
    };
    // Initial check
    updateDimensions();

    // Update dimensions on resize
    window.addEventListener("resize", updateDimensions);

    // Cleanup on unmount
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div>
      <Constaint>
        <div className="grid p-16 mt-10 mb-24 place-content-center">
          <iframe
            width={dimensions.width}
            height={dimensions.height}
            className="border-t-[16px] border-Blue00"
            src="https://www.youtube.com/embed/CKJp2CoZSOY?si=UOnKlJjsMBU5p_Ps&amp;controls=1"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
          <div className="mx-auto mt-4 w-max">
            <StartMockBtn />
          </div>
        </div>
      </Constaint>
    </div>
  );
};

export default FeaturedVideo;
